import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import download from 'downloadjs';

export const COMPETITION_MANDATE_COMMISSION_PROTOCOL_REQUEST = 'FETCH_COMPETITION_MANDATE_COMMISSION_PROTOCOL_REQUEST';
export const COMPETITION_MANDATE_COMMISSION_PROTOCOL_FAILURE = 'FETCH_COMPETITION_MANDATE_COMMISSION_PROTOCOL_FAILURE';
export const COMPETITION_MANDATE_COMMISSION_PROTOCOL_SUCCESS = 'FETCH_COMPETITION_MANDATE_COMMISSION_PROTOCOL_SUCCESS';

export const fetchCompetitionMandateCommissionProtocolReport = competition => {
    return function(dispatch) {
        dispatch(fetchRequest());

        return axios(apiRequestOptions(apiPath.REPORTS.COMPETITION_MANDATE_COMMISSION_PROTOCOL, null, {
            params: {competition},
            isBlob: true,
        }))
            .then(transformHttpResponse)
            .then(response => {
                const content = response.headers['content-type'];
                const contentDisposition = response.headers['content-disposition'] || '';
                const filenameMatch = contentDisposition.match(/filename="?([^";\s]+)"?/);
                const filename = filenameMatch ? filenameMatch[1] : 'report.pdf';
                download(response.data, filename, content);
                dispatch(fetchSuccess());
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = () => ({type: COMPETITION_MANDATE_COMMISSION_PROTOCOL_REQUEST});

const fetchFailure = error => ({type: COMPETITION_MANDATE_COMMISSION_PROTOCOL_FAILURE, error,});

const fetchSuccess = () => ({type: COMPETITION_MANDATE_COMMISSION_PROTOCOL_SUCCESS});
